import { SearchIcon } from "./icons";

const NoCompaniesFound = ({ term }: { term: string }) => (
  <div className="text-center py-12">
    <div className="bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
      <SearchIcon className="h-8 w-8 text-gray-400" />
    </div>
    <h3 className="text-lg font-medium text-gray-900 mb-2">
      No companies found
    </h3>
    <p className="text-gray-600">
      We couldn&apos;t find any companies matching &quot;{term}&quot;. Try
      searching with a different name or RC number.
    </p>
  </div>
);

export default NoCompaniesFound;
